<template>
  <div class="ex-list">
    <exhibitionItem v-for="(item) in datas" :data="item" :key="item.id"></exhibitionItem>
  </div>
</template>
<script>
import exhibitionItem from './exhibitionItem'

export default {
  name: 'ExhibitionList',
  props: { datas: Array },
  components: { exhibitionItem }
}
</script>
<style scoped>
.ex-list {
  margin-right: -21px;
  overflow: hidden;
}
</style>
